import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[hoverClass]',
})
export class HoverClassDirective {
    constructor(public elementRef: ElementRef) {}

    @Input() hoverClass = '';

    @HostListener('mouseenter') onMouseEnter() {
        this.getClassList().forEach((item) => {
            this.elementRef.nativeElement.classList.add(item);
        });
    }

    @HostListener('mouseleave') onMouseLeave() {
        this.getClassList().forEach((item) => {
            this.elementRef.nativeElement.classList.remove(item);
        });
    }

    private getClassList() {
        return this.hoverClass.trim().split(' ');
    }
}
